import env from '../pages/MyAccount/utils/env';

const redirectToLogin = () => {
  window.location.assign(`${env.loginUrl}${window.location.href}`);
};

const redirectToBaseSite = () => window.location.replace(process.env.REACT_APP_SITE_URL);

export { redirectToLogin, redirectToBaseSite };
